import { render } from "./dashboard.vue?vue&type=template&id=7ee85a6f&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=7ee85a6f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ee85a6f"

export default script